module.exports = __webpack_public_path__ + "img/motorsports-helmet.58e84dca.svg";